import * as yup from "yup";
import { LocalizationService } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";

interface ValidationParams {
  scheduleNames: string[];
  localizationService: LocalizationService;
  currentName?: string;
}

export default function SchedulesValidationSchema({ scheduleNames, localizationService, currentName }: ValidationParams) {
  return yup.object().shape({
    name: yup
      .string()
      .min(2)
      .max(48)
      .required(localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired))
      .test(
        'unique-name',
        localizationService.toLanguageString('custom.scheduleNameExists', enMessages.custom.uniqueName),
        function(value) {
          if (!value) return true;
          
          // Check current name
          if (currentName && value.toLowerCase() === currentName.toLowerCase()) {
            return true;
          }

          // Check for duplicates
          return !scheduleNames.some(
            existingName => existingName.toLowerCase() === value.toLowerCase()
          );
        }
      ),
    description: yup
      .string()
      .min(2)
      .max(48),
    recurrence: yup
      .number()
      .positive()
      .min(1)
      .max(999),
    timezone: yup.string(),
    startDate: yup.date().required(),
    endDate: yup.date().nullable(true),
  });
}